module.exports = __webpack_public_path__ + "img/Cheer Megaphone33.92e535a4.jpg";